import { IconName } from '@infotech-soe/erp-ui-kit';
import { THotKey } from '@infotech-soe/metaschema';

import {
  BuiltinCaptionType,
  Caption,
  CaptionType,
} from '../../../models/caption/Caption';
import CategoryCommandImpl from '../impl/CategoryCommandImpl';

import CategoryCommand from './CategoryCommand';

class PrintCommand extends CategoryCommand<Record<string, any>> {
  constructor(
    commandImpl: CategoryCommandImpl<Record<string, any>>,
    private caption: string,
    private icon?: IconName,
    private menuLabel?: string,
    private hotKey?: THotKey
  ) {
    super(commandImpl);
  }

  public async getCaption(): Promise<Caption> {
    return this.caption === this.getName()
      ? { type: CaptionType.BUILT_IN, caption: BuiltinCaptionType.PRINT }
      : { type: CaptionType.EXTERNAL, caption: this.caption };
  }

  public getIcon(): IconName {
    return this.icon ?? 'print';
  }

  public getMenuLabel(): string | undefined {
    return this.menuLabel;
  }

  public getHotKey(): THotKey | undefined {
    return this.hotKey;
  }
}

export default PrintCommand;
